import React from "react";
import { Button, Flex, Image, Text } from "@chakra-ui/react";
import SVG from "react-inlinesvg";
import { highlightPartialText } from "@/utils/highlightSearch";

interface Props {
  src: string;
  brandName?: string;
  sku: string;
  added?: boolean;
  value?: string;
  onClick: () => void;
}

function FavoriteProductEditItem({
  src,
  brandName,
  sku,
  added,
  value,
  onClick,
}: Props) {
  return (
    <Flex
      // "justify-between"은 유효한 CSS 값이 아니라 무시돼 왔다. 오른쪽 밀어내기는
      // 안쪽 Flex의 flex={1}이 이미 해주므로 값만 바로잡는다.
      justifyContent={"space-between"}
      alignItems={"center"}
      flex={1}
      paddingRight={"8px"}
      marginBottom={"8px"}
    >
      <Flex gap={"12px"} alignItems={"center"} flex={1} minWidth={0}>
        <Image
          src={src}
          width={"68px"}
          height={"68px"}
          flexShrink={0}
          fallbackSrc={"/icons-v1_1/null.png"}
          alt={brandName}
        />
        {/* minWidth 0이 없으면 긴 SKU가 축소되지 않고 별 버튼을 카드 밖으로 밀어낸다. */}
        <Flex flexDirection={"column"} gap={"2px"} minWidth={0}>
          <Text textStyle={"body-sm-bold"}>{brandName}</Text>
          <Text textStyle={"body-sm-regular"}>
            {highlightPartialText(sku, [value])}
          </Text>
        </Flex>
      </Flex>
      <Button
        display={"flex"}
        variant={"ghost"}
        flexShrink={0}
        gap={"4px"}
        alignItems={"center"}
        cursor={"pointer"}
        color={added ? "#1272EF" : "#8F8F8C"}
        onClick={() => onClick()}
        _hover={{
          background: "inherit",
          color: added ? "#005AAD" : "#1272EF",
        }}
        _active={{
          background: "inherit",
          color: "#00417D",
        }}
      >
        <SVG
          src={`/icons-v1_1/${added ? "star-solid" : "star"}.svg`}
          width={24}
          height={24}
        />
      </Button>
    </Flex>
  );
}

export default FavoriteProductEditItem;
